module.exports = __webpack_public_path__ + "static/media/Hl1.4f549f92.jpg";